import { render, staticRenderFns } from "./NetSuiteFormPopover.vue?vue&type=template&id=4bbf94cc&scoped=true&"
import script from "./NetSuiteFormPopover.vue?vue&type=script&lang=js&"
export * from "./NetSuiteFormPopover.vue?vue&type=script&lang=js&"
import style0 from "./NetSuiteFormPopover.vue?vue&type=style&index=0&id=4bbf94cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf94cc",
  null
  
)

export default component.exports